module.exports = __webpack_public_path__ + "img/cms-logo-wordpress.0bf4a7d4.png";